import CONSTANTS from '../constants'
import { EMPTY_OBJECT } from '../../constants/globalConstants'

const INITIAL_STATE = {
	loader: false,
	extend_loader: false,
	isAuthenticated: false,
	hasError: false,
	data: EMPTY_OBJECT,
	faclityData: EMPTY_OBJECT,
	email: null,
	role: null,
	errorMessage: '',
	id: null,
	orgId: '',
	endTicketData: EMPTY_OBJECT,
	activeRateBandsClick: true,
	promoCodeMsge: false,
	priceBandAPI: false,
	facility_loaded: false,
	fetchRateLoader: false,
	selectedHours: '0.00',
	isWelcomePopup: '0'
}

const transientReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		// get facilty reducer 
		case CONSTANTS.GET_FACILITY_RATE_REQUEST:
			return {
				...state,
				loader: true,
				fetchRateLoader: true,
				errorMessage: ''
			}
		case CONSTANTS.GET_FACILITY_RATE_SUCCESS:
			return {
				...state,
				loader: false,
				fetchRateLoader: false,
				faclityData: action.data,
				isAuthenticated: true,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.GET_FACILITY_RATE_FAILURE:
			return {
				...state,
				loader: false,
				fetchRateLoader: false,
				errorMessage: 'There is some Error'
			}

		// for the payment api 
		case CONSTANTS.POST_CARD_PAYMENT_REQUEST:
			return {
				...state,
				loader: true,
				fetchRateLoader: false,
				errorMessage: ''
			}
		case CONSTANTS.POST_CARD_PAYMENT_SUCCESS:
			return {
				...state,
				loader: false,
				fetchRateLoader: false,
				faclityData: action.data,
				isAuthenticated: true,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.POST_CARD_PAYMENT_FAILURE:
			return {
				...state,
				loader: false,
				fetchRateLoader: false,
				errorMessage: 'There is some Error'
			}

		// End Parking
		case CONSTANTS.END_PARKING_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: ''
			}
		case CONSTANTS.END_PARKING_SUCCESS:
			return {
				...state,
				loader: false,
				endTicketData: action.data,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.END_PARKING_FAILURE:
			return {
				...state,
				loader: false,
				hasError: true,
				errorMessage: 'There is some Error'
			}
		// End Parking
		case CONSTANTS.FACILITY_ON_MARKER_REQUEST:
			return {
				...state,
				loader: true,
				fetchRateLoader: false,
				errorMessage: ''
			}
		case CONSTANTS.FACILITY_ON_MARKER_SUCCESS:
			return {
				...state,
				loader: false,
				fetchRateLoader: false,
				// endTicketData: action.data,
				hasError: false,
				errorMessage: ''
			}
		case CONSTANTS.FACILITY_ON_MARKER_FAILURE:
			return {
				...state,
				loader: false,
				fetchRateLoader: false,
				hasError: true,
				errorMessage: 'There is some Error'
			}

		// Reservation ID
		case CONSTANTS.PROMOCODE_REQUEST:
			return {
				...state,
				loader: true,
				errorMessage: '',
				activeRateBandsClick: false
			}
		case CONSTANTS.PROMOCODE_SUCCESS:
			return {
				...state,
				loader: false,
				// endTicketData: action.data,
				hasError: false,
				errorMessage: '',
				activeRateBandsClick: true
			}
		case CONSTANTS.PROMOCODE_FAILURE:
			return {
				...state,
				loader: false,
				hasError: true,
				errorMessage: 'There is some Error',
				activeRateBandsClick: true
			}
		case CONSTANTS.PROMOCODE_TICKET_REQUEST:
			return {
				...state,
				activeRateBandsClick: false
			}
		case CONSTANTS.PROMOCODE_TICKET_SUCCESS:
			return {
				...state,
				activeRateBandsClick: true
			}
		case CONSTANTS.PROMOCODE_TICKET_FAILURE:
			return {
				...state,
				activeRateBandsClick: true
			}
		case CONSTANTS.PROMO_MSGE_ENABLE:
			return {
				...state,
				promoCodeMsge: true
			}
		case CONSTANTS.PROMO_MSGE_DISABLE:
			return {
				...state,
				promoCodeMsge: false
			}
		case CONSTANTS.GET_RATE_BANDS_REQUEST:
			return {
				...state,
				priceBandAPI: true
			}
		case CONSTANTS.GET_RATE_BANDS_SUCCESS:
			return {
				...state,
				priceBandAPI: false
			}
		case CONSTANTS.GET_RATE_BANDS_FAILURE:
			return {
				...state,
				priceBandAPI: false
			}
		case CONSTANTS.FACILITY_LOADED:
			return {
				...state,
				facility_loaded: true
			}
		case CONSTANTS.EXTEND_CARD_HOUR_REQUEST:
			return {
				...state,
				extend_loader: true
			}
		case CONSTANTS.EXTEND_CARD_HOUR_SUCCESS:
			return {
				...state,
				extend_loader: false
			}
		case CONSTANTS.EXTEND_CARD_HOUR_FAILURE:
			return {
				...state,
				extend_loader: false
			}
		case CONSTANTS.UPDATE_SELECTED_HOURS:
			return {
				...state,
				selectedHours: action.hours
			}
		case CONSTANTS.IS_WELCOME_POPUP:
			return {
				...state,
				isWelcomePopup: action?.data
			}
		default:
			return state
	}
}

export default transientReducer
